// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"54":"959c82cd","184":"26ca9b82","226":"49bc27d6","250":"ea8e183a","262":"edd1a7f4","469":"aeec99fa","484":"1da89009","579":"e953c317","619":"7bf34f08","812":"48cf187a","917":"bad928e4","935":"c6180389","993":"1e2e4a0e"}[chunkId] + ".js";
};